// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/home Components/Home.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import JobList from '../home Components/JobList';
import Notification from '../shared/Notification';
import './home.css';
import NavHeader from '../shared/Nav-Header';
import CreateJob from '../home Components/Create-Job';

const RecruiterHome = () => {
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/recruiter/login');
            return;
        }

        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }
    }, [navigate]);

    const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <div className="home">
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <CreateJob />
            {/* <RecentApplications /> */}
        </div>
    );
};

export default RecruiterHome;